// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2097":"c40734de","3578":"021961e7","4283":"c40734de","6186":"c40734de","6689":"c40734de"}[chunkId] + ".chunk.css";
};